import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-insights-loader',
  templateUrl: './insights-loader.component.html',
  styleUrls: ['./insights-loader.component.css']
})
export class InsightsLoaderComponent {
   @Input() label: string = 'Generating insights';
}
